var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon Trophy",
    d: "M3.38513 6.47266V5.97266V5.47266H4.63513V8.15019C3.91226 7.93505 3.38513 7.26541 3.38513 6.47266ZM0.914233 6.97266C1.1496 8.98104 2.78527 10.5614 4.81865 10.711C5.22931 12.0614 6.28643 13.1212 7.63513 13.5356V14.3841L4.19944 15.7584L3.88513 15.8841V16.2227V16.9727V17.4727H4.38513H13.3851H13.8851V16.9727V16.2227V15.8841L13.5708 15.7584L10.1351 14.3841V13.5356C11.4836 13.1213 12.5406 12.0617 12.9514 10.7116C13.9477 10.6373 14.8909 10.2136 15.6104 9.50822C16.306 8.82631 16.7425 7.93012 16.8557 6.97266H16.8851V6.47426C16.8851 6.47372 16.8851 6.47319 16.8851 6.47266C16.8851 6.47262 16.8851 6.47259 16.8851 6.47256V3.47266V2.97266H16.3851H13.1351V1.97266V1.47266H12.6351H5.13513H4.63513V1.97266V2.97266H1.38513H0.885132V3.47266V5.97266V6.47266V6.97266H0.914233ZM14.3851 6.47266C14.3851 7.26541 13.858 7.93505 13.1351 8.15019V5.47266H14.3851V5.97266V6.47266Z",
    fill: "#107F47",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.eaeeaa7be83e5069293875aaaf4ef215.svg";
export { ForwardRef as ReactComponent };